export interface NotificationItem {
  id: string;
  type: 'payment' | 'scheme' | 'gold_rate' | 'redemption' | 'kyc' | 'promo' | 'loan' | 'goal' | 'system';
  title: string;
  description: string;
  time: string;
  timestamp: Date;
  read: boolean;
  actionable: boolean;
  actionLabel?: string;
  /** In-app route this notification opens (replaces the old label-string -> route switch). */
  deepLink: string;
}

export const notifications: NotificationItem[] = [
  {
    id: 'n1',
    type: 'payment',
    title: 'Payment Successful',
    description: 'Your monthly instalment of Rs. 2,500 for Gold Saver Plus scheme has been processed successfully.',
    time: '10:32 AM',
    timestamp: new Date('2026-07-01T10:32:00'),
    read: false,
    actionable: true,
    actionLabel: 'View Receipt',
    deepLink: '/account/ledger',
  },
  {
    id: 'n2',
    type: 'gold_rate',
    title: 'Gold Rate Alert',
    description: '24K Gold rate has dropped to Rs. 6,245/g. It might be a good time to invest. Current rate is 2.1% below your average purchase rate.',
    time: '09:15 AM',
    timestamp: new Date('2026-07-01T09:15:00'),
    read: false,
    actionable: true,
    actionLabel: 'View Schemes',
    deepLink: '/schemes',
  },
  {
    id: 'n3',
    type: 'scheme',
    title: 'Scheme Maturity Reminder',
    description: 'Your Gold Saver Plus scheme will mature on 15 August 2026. You currently hold 18.5g of gold worth Rs. 1,15,500. Plan your redemption now.',
    time: 'Yesterday',
    timestamp: new Date('2026-06-30T18:45:00'),
    read: false,
    actionable: true,
    actionLabel: 'View Details',
    deepLink: '/schemes',
  },
  {
    id: 'n4',
    type: 'redemption',
    title: 'Redemption Initiated',
    description: 'Your redemption request for 5g of 24K gold coin has been initiated. Amount Rs. 31,225 will be credited within 2-3 business days.',
    time: 'Yesterday',
    timestamp: new Date('2026-06-30T14:20:00'),
    read: true,
    actionable: true,
    actionLabel: 'Track Status',
    deepLink: '/account/redemptions',
  },
  {
    id: 'n5',
    type: 'goal',
    title: 'Goal Milestone!',
    description: 'Congratulations! You have reached 65% of your "Wedding Gold" goal. Only Rs. 42,000 more to go. Keep up the great progress.',
    time: 'Jun 29',
    timestamp: new Date('2026-06-29T11:00:00'),
    read: true,
    actionable: true,
    actionLabel: 'View Goals',
    deepLink: '/account/goals',
  },
  {
    id: 'n6',
    type: 'system',
    title: 'e-KYC Verification Complete',
    description: 'Your e-KYC verification has been completed successfully. All platform features including redemptions and loans are now available.',
    time: 'Jun 28',
    timestamp: new Date('2026-06-28T16:30:00'),
    read: true,
    actionable: false,
    deepLink: '/account/profile',
  },
  {
    id: 'n7',
    type: 'payment',
    title: 'Auto-Debit Mandate Active',
    description: 'Your auto-debit mandate for monthly instalments is now active. Next debit of Rs. 2,500 is scheduled for 1st August 2026.',
    time: 'Jun 27',
    timestamp: new Date('2026-06-27T09:00:00'),
    read: true,
    actionable: false,
    deepLink: '/account/ledger',
  },
  {
    id: 'n8',
    type: 'promo',
    title: 'Monsoon Gold Fest is Live!',
    description: 'Enjoy zero making charges on all gold coins this month. Also get an extra 1% bonus gold on investments above Rs. 50,000. Offer ends 31st July.',
    time: 'Jun 26',
    timestamp: new Date('2026-06-26T12:00:00'),
    read: true,
    actionable: false,
    deepLink: '/schemes',
  },
  {
    id: 'n9',
    type: 'loan',
    title: 'Loan Against Gold - Pre-Approved',
    description: 'You are pre-approved for a loan of up to Rs. 75,000 against your gold holdings. Interest rate starts at 8.5% p.a. No credit score needed.',
    time: 'Jun 25',
    timestamp: new Date('2026-06-25T10:15:00'),
    read: true,
    actionable: true,
    actionLabel: 'Check Eligibility',
    deepLink: '/account',
  },
  {
    id: 'n10',
    type: 'scheme',
    title: 'New Scheme Enrolled',
    description: 'You have successfully enrolled in the Gold SIP 2026 scheme. Monthly instalment of Rs. 1,000 will be debited starting from 5th July 2026.',
    time: 'Jun 24',
    timestamp: new Date('2026-06-24T15:45:00'),
    read: true,
    actionable: true,
    actionLabel: 'View Scheme',
    deepLink: '/schemes',
  },
  {
    id: 'n11',
    type: 'gold_rate',
    title: 'Gold Reaches All-Time High',
    description: '24K Gold has hit a new all-time high of Rs. 6,580/g in domestic markets. Your portfolio value has increased by 8.3% this quarter.',
    time: 'Jun 22',
    timestamp: new Date('2026-06-22T14:30:00'),
    read: true,
    actionable: false,
    deepLink: '/account/ledger',
  },
  {
    id: 'n12',
    type: 'payment',
    title: 'Instalment Reminder',
    description: 'Your monthly instalment of Rs. 3,000 for Gold Builder Pro is due on 5th July. Ensure sufficient balance in your linked account.',
    time: 'Jun 20',
    timestamp: new Date('2026-06-20T08:00:00'),
    read: true,
    actionable: true,
    actionLabel: 'Pay Now',
    deepLink: '/account/ledger',
  },
  {
    id: 'n13',
    type: 'redemption',
    title: 'Redemption Completed',
    description: 'Your redemption of 2g gold bar has been processed. Rs. 12,490 has been credited to your bank account ending with 3210.',
    time: 'Jun 18',
    timestamp: new Date('2026-06-18T11:20:00'),
    read: true,
    actionable: false,
    deepLink: '/account/redemptions',
  },
  {
    id: 'n14',
    type: 'system',
    title: 'Security Update',
    description: 'A new device login was detected on your account. If this was not you, please change your MPIN immediately from the Security Settings.',
    time: 'Jun 15',
    timestamp: new Date('2026-06-15T20:10:00'),
    read: true,
    actionable: true,
    actionLabel: 'Security Settings',
    deepLink: '/account/profile',
  },
];

function getGroupLabel(date: Date): string {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today.getTime() - 86400000);
  const weekAgo = new Date(today.getTime() - 7 * 86400000);

  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  if (d.getTime() === today.getTime()) return 'Today';
  if (d.getTime() === yesterday.getTime()) return 'Yesterday';
  if (d.getTime() > weekAgo.getTime()) return 'This Week';
  return 'Earlier';
}

export interface NotificationGroup {
  label: string;
  items: NotificationItem[];
}

export function groupNotifications(items: NotificationItem[]): NotificationGroup[] {
  const groups: Record<string, NotificationItem[]> = {};
  for (const item of items) {
    const key = getGroupLabel(item.timestamp);
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
  }
  const order = ['Today', 'Yesterday', 'This Week', 'Earlier'];
  return order.filter((k) => groups[k]).map((k) => ({ label: k, items: groups[k] }));
}